import React from "react";

function CancelReservationsButton({ onClick, disabled }) {
  return (
    <button
      className="cancel-button"
      onClick={onClick}
      disabled={disabled}
    >
      🗑️ USUŃ WYBRANE REZERWACJE
    </button>
  );
}

export default CancelReservationsButton;